<template lang="pug">
#app
  LoginLayout(v-if="layout === 'login'")
    router-view
  CompeteLayout(v-else-if="layout === 'compete' && !isMobile")
    router-view
  SchoolLayout(v-else-if="layout === 'school'")
    router-view
  AdminLayout(v-else-if="layout === 'admin'")
    router-view
  DefaultLayout(v-else-if="layout === 'default'")
    router-view
  CenterLayout(v-else-if="layout === 'center'")
    router-view
  router-view(v-else)
</template>

<script>
import LoginLayout from '@/layouts/LoginLayout';
import CompeteLayout from '@/layouts/CompeteLayout';
import SchoolLayout from '@/layouts/SchoolLayout';
import AdminLayout from '@/layouts/Admin';
import CenterLayout from '@/layouts/CenterLayout';
import DefaultLayout from '@/layouts/DefaultLayout';

export default {
  name: 'app',
  components: {
    LoginLayout,
    CompeteLayout,
    SchoolLayout,
    AdminLayout,
    CenterLayout,
    DefaultLayout,
  },
  data() {
    return {
      isMobile: false,
      isCollapse: false,
    };
  },
  beforeMount() {
    this.isMobile = screen.width <= 480;
    this.$store.dispatch('isMobile', this.isMobile);
    window.addEventListener('resize', this.handleResize);
  },
  mounted() {
    this.isMobile = document.body.clientWidth <= 480;
    this.$store.dispatch('isMobile', this.isMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    layout() {
      return this.$route.meta.layout;
    },
  },
  watch: {
    $route() {
      document.title = this.$route.meta.title;
    },
  },
  methods: {
    handleResize(e) {
      this.isMobile = e.target.innerWidth <= 480;
      this.$store.dispatch('isMobile', this.isMobile);
      // adminSideMenu
      if (e.target.innerWidth > 1440) {
        this.isCollapse = false;
      } else if (e.target.innerWidth <= 1440) {
        this.isCollapse = true;
      }
      this.$store.commit('TOGGLE_SIDE_MENU', this.isCollapse);
      this.$store.commit('SET_SCREENWIDTH', e.target.innerWidth);
    },
  },
};
</script>

<style lang="stylus">
#app
  font-family 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  width 100%
  height 100%
  .red
    color #E46D69
  .todoBtn
    background #7FA5A4
    border-color #7FA5A4
    color #fff
  .todoBtn:hover
    background #fff
    color #7FA5A4
  .deleteBtn
    background #E46D69
    border-color #E46D69
    color #fff
  .deleteBtn:hover
    background #fff
    color #E46D69
  .el-tabs__nav
    display flex
    width 100%
    text-align center
    .el-tabs__item
      flex 1
  .vue-html5-editor
    .content
      max-height 300px
  .compete-content-html
    img
      width 100%
  // text ellipsis
  .signle-line
    overflow hidden
    text-overflow ellipsis
    white-space nowrap
  mutiple-line(n)
    display -webkit-box
    -webkit-box-orient vertical
    -webkit-line-clamp n
    overflow hidden
  .two-line
    mutiple-line(2)
  .three-line
    mutiple-line(3)

.appbarItem
  width 100%
  text-align center
</style>



// WEBPACK FOOTER //
// App.vue?3c8c8f00